import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { NumberField } from "../../../components/forms/number";
import { Toggle } from "../../../components/forms/toggle";
import { Permission } from "../../../components/permission";
import { LaunchConfigurationsDTO } from "../../../store/launch-configurations/models/dto";
import {
  Container,
  FieldSection,
  FieldSubSection,
  SectionTitle,
} from "./common/components";
import { useNewLaunchContext } from "./context";

export const Other: React.FunctionComponent<{}> = () => {
  // const { setValidation } = useContext(StepperContext);

  const { isCrypto } = useNewLaunchContext();

  // const schema = LaunchConfigurationsDTO.Requests.SetSingle.useSchema();
  // const resolver = useMemo(() => schema.pick(["css"]), [schema]); // TODO
  // const isMounted = useIsMounted();

  const {
    control,
  } = useFormContext<LaunchConfigurationsDTO.Requests.SetSingle.T>();

  // useEffect(() => {
  //   const sub = watch((data) => {
  //     setValidation(() => () => resolver.validate(data));
  //   });

  //   return () => {
  //     sub.unsubscribe();
  //     if (isMounted.current) {
  //       // We have to check if it's mounted otherwise it will clear current validation
  //       // This is because the prior page's clear validation is run after the new page's setValidation
  //       setValidation(() => () => Promise.resolve());
  //     }
  //   };
  // }, [setValidation, resolver, isMounted.current]);

  return (
    <Container>
      <Permission roles={["ROLE_ADMIN"]}>
        <FieldSection>
          <SectionTitle>Merchant ID</SectionTitle>
          <Controller
            control={control}
            name="configuration.merchantConfig.merchantId"
            render={({ field, fieldState: { error } }) => (
              <Toggle {...field} error={!!error} helperText={error?.message} />
            )}
          />
        </FieldSection>
      </Permission>
      <Permission roles={["ROLE_ADMIN"]}>
        <FieldSection>
          <SectionTitle>Pre-Verified Source Wallet</SectionTitle>
          <Controller
            control={control}
            name="configuration.merchantConfig.preVerifiedSourceWallet"
            defaultValue={false}
            render={({ field, fieldState: { error } }) => (
              <Toggle {...field} error={!!error} helperText={error?.message} />
            )}
          />
        </FieldSection>
        <FieldSection>
          <SectionTitle>Create User Profile</SectionTitle>
          <Controller
            control={control}
            name="configuration.merchantConfig.createUserProfile"
            defaultValue={false}
            render={({ field, fieldState: { error } }) => (
              <Toggle {...field} error={!!error} helperText={error?.message} />
            )}
          />
        </FieldSection>
      </Permission>
      <FieldSection>
        <SectionTitle>Perform AML Checks</SectionTitle>
        <em>
          Perform anti-money laundering checks in addition to the regular know
          your customer (KYC) checks
        </em>
        <br />
        <Controller
          control={control}
          name="configuration.merchantConfig.performBackgroundChecks"
          defaultValue={false}
          render={({ field, fieldState: { error } }) => (
            <Toggle {...field} error={!!error} helperText={error?.message} />
          )}
        />
      </FieldSection>
      <Permission roles={["ROLE_ADMIN"]}>
        <FieldSection>
          <SectionTitle>Perform 2 Factor Auth</SectionTitle>
          <Controller
            control={control}
            name="configuration.merchantConfig.performOtp"
            defaultValue={false}
            render={({ field, fieldState: { error } }) => (
              <Toggle {...field} error={!!error} helperText={error?.message} />
            )}
          />
        </FieldSection>
      </Permission>

      <FieldSection>
        <SectionTitle>Confirmation E-mail</SectionTitle>
        <em>
          Send the user an e-mail when he/she has been successfully verified.
        </em>
        <br />
        <Controller
          control={control}
          name="configuration.participationServices.messageSendingWhenVerified"
          defaultValue={false}
          render={({ field, fieldState: { error } }) => (
            <Toggle {...field} error={!!error} helperText={error?.message} />
          )}
        />
      </FieldSection>

      {isCrypto ? (
        <>
          <FieldSection>
            <SectionTitle>On-Chain Analysis</SectionTitle>
            <FieldSubSection>
              <Controller
                control={control}
                name="configuration.participationServices.onchainAnalysis.enabled"
                defaultValue={false}
                render={({ field, fieldState: { error } }) => (
                  <Toggle
                    {...field}
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />
              <span>Enabled</span>
            </FieldSubSection>
            <FieldSubSection>
              <Controller
                control={control}
                name="configuration.participationServices.onchainAnalysis.realtime"
                defaultValue={false}
                render={({ field, fieldState: { error } }) => (
                  <Toggle
                    {...field}
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />
              <span>Realtime</span>
            </FieldSubSection>
            <FieldSubSection>
              <strong>Max Treshold</strong>
              <br />
              <Controller
                control={control}
                name="configuration.participationServices.onchainAnalysis.maxThreshold"
                render={({ field, fieldState: { error } }) => (
                  <NumberField
                    {...field}
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />
            </FieldSubSection>
          </FieldSection>
        </>
      ) : null}
    </Container>
  );
};
